import { createStore } from 'vuex';
import axios from 'axios'


const ax = axios.create({
  withCredentials: true,
  baseURL: "https://uti.umbgrup.ro",
});

// function isTokenExpired(token) {
//   const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
//   return (Math.floor((new Date).getTime() / 1000)) >= expiry;
// }
function isRefreshOk(token) {
  try {
    const tk = JSON.parse(atob(token.split('.')[1]));
    const isRef = tk.token_type == "refresh";
    const isInTime = (Math.floor((new Date).getTime() / 1000)) < tk.exp;
    return isRef && isInTime
  } catch (err) {
    return false;
  }

}


export default createStore({
  state: {
    authToken: localStorage.getItem('authToken') || null,
    refreshToken: localStorage.getItem('refreshToken') || null,
    authenticated: false,
  },
  mutations: {
    setAuthToken(state, token) {
      state.authToken = token
      localStorage.setItem('authToken', token)
    },
    setRefreshToken(state, token) {
      state.refreshToken = token
      localStorage.setItem('refreshToken', token)
    },
    clearAuthTokens(state) {
      state.authToken = null
      state.refreshToken = null
      localStorage.removeItem('authToken')
      localStorage.removeItem('refreshToken')
    },
    setAuthenticated(state, payload) {
      state.authenticated = payload
    }
  },
  actions: {
    async login({ commit }, { username, password }) {
      const formData = { username: username, password: password };
      //console.log(formData);
      const resp = await ax.post("rest_api/token/", formData);
      const { access, refresh } = await resp.data;

      commit('setAuthToken', access)
      commit('setRefreshToken', refresh)
      commit('setAuthenticated', access != null && refresh != null)
    },
    async rrefreshToken({ state, commit }) {
      if (!isRefreshOk(state.refreshToken)) {
        commit("clearAuthTokens", null);
        this.$router.push("/login");
      } else {
        const formData = { refresh: state.refreshToken };
        try {
          const resp = await fetch("https://uti.umbgrup.ro/rest_api/token/refresh/",
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(formData)
            });
          const { access, refresh } = await resp.json();
          commit('setAuthToken', access)
          commit('setRefreshToken', refresh)
          commit('setAuthenticated', access != null && refresh != null)
        } catch {
          commit("clearAuthTokens", null);
          this.$router.push("/login");
        }
      }
    },
    async logout({ commit }) {
      //const formData = { uita: "dummy thing to do" };
      //const resp = ax.post("rest_api/token/refresh/", formData);
      commit("clearAuthTokens", null);
      //ax.defaults.headers["Authorization"] = `Bearer `;

    },
    checkAuthenticated({ commit }) {
      const token = localStorage.getItem('authToken')
      const rtoken = localStorage.getItem('refreshToken')
      if (token && rtoken && token.length > 20 && rtoken.length > 20) commit('setAuthenticated', true)
      else commit('setAuthenticated', false)
    }
  }
})



